/* eslint-disable camelcase */
import React from 'react';
import {Button, Card, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {} = Actions;

const Header = ({
  disabled,
  messageSave,
  handleSave,
}) => {
  return (
    <Card fluid>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <h2>
            Administración de cupo diario
          </h2>
          <div className="title-bar-actions">
            <Popup
              disabled={!disabled}
              position='bottom left'
              size='small'
              inverted
              trigger={
                <span>
                  <Button
                    primary
                    color='red'
                    onClick={handleSave}
                    disabled={disabled}
                  >
                    Guardar
                  </Button>
                </span>
              }>
              {<p>{messageSave}</p>}
            </Popup>

          </div>
        </div>
      </div>
    </Card>
  );
};

export default Header;
